import { queryOptions } from '@tanstack/react-query';

import { API_ENDPOINT } from '~/config';
import { Partner } from '~/types/interfaces';

export const getPartner = (positionId: string) =>
  queryOptions({
    queryKey: ['getPartner', positionId],
    queryFn: async (): Promise<Partner> => {
      const response = await fetch(`${API_ENDPOINT}/partner/${positionId}`);

      if (!response.ok) {
        throw new Error(`Error fetching partner data: ${response.statusText}`);
      }

      const partner = (await response.json()) as Partner;

      return partner;
    },
  });
